module.exports = __webpack_public_path__ + "img/world_hard_menu.764323a6.png";